import { useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { dashboardColumns } from "./grid/dashboardColumnsAdmin";
import { updateDashboardData } from "./api/dashboardApiAdmin";
import { toast } from "react-toastify";
import { validateEditPassword } from "./api/dashboardApiAdmin";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";

// AG Grid Community Registration
ModuleRegistry.registerModules([AllCommunityModule]);



function DashboardGrid({ rowData, setFilteredData }) {
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [password, setPassword] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [isEditAuthenticated, setIsEditAuthenticated] = useState(false);
  const originalRowRef = useRef({});

  const [editingRow, setEditingRow] = useState(null);
  const gridRef = useRef(null);

  const [searchText, setSearchText] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const defaultColDef = {
    sortable: true,
    filter: true,
    floatingFilter: true,
    resizable: true,
    minWidth: 150,
  };

  const onFilterChanged = () => {
    const rows = [];

    gridRef.current.api.forEachNodeAfterFilter((node) => {
      rows.push(node.data);
    });

    setFilteredData(rows);
  };

  const onSearchChange = (e) => {
    const value = e.target.value;

    setSearchText(value);

    gridRef.current.api.setGridOption("quickFilterText", value);
  };
  const exportExcel = () => {
    gridRef.current.api.exportDataAsCsv({
      fileName: "GIS_MPHS_Dashboard.csv",
    });
  };

  /*-------------------- For Future Use: Inline Editing -------------------*/
  /* const updateRow = async (row) => {

    try {

        const response =
            await updateDashboardData(row);

        console.log(response);

        alert(
            "Record Updated Successfully"
        );

        setEditingRow(null);

        gridRef.current.api.refreshCells({
            force: true
        });

    }
    catch (error) {

        console.error(error);

        console.log(error.response);

        alert(
            error.response?.data?.message ||
            JSON.stringify(error.response?.data)
        );
    }
}; */

  const updateRow = async (row) => {
    try {
      const response = await updateDashboardData(row);

      //console.log(response);
      toast.success("Record Updated Successfully");
      //alert("Updated Successfully");

      setEditingRow(null);
    } catch (error) {
      console.log("FULL ERROR", error);

      console.log("RESPONSE", error.response);

      console.log("DATA", error.response?.data);
      toast.error("Update Failed");
      alert(JSON.stringify(error.response?.data));
    }
  };
  /*-------------------- For Future Use: Inline Editing -------------------*/

  const cancelEdit = () => {
    const rowNode = gridRef.current.api.getRowNode(editingRow);

    if (rowNode) {
      Object.assign(rowNode.data, originalRowRef.current);

      gridRef.current.api.refreshCells({
        rowNodes: [rowNode],
        force: true,
      });
    }

    setEditingRow(null);

    gridRef.current.api.redrawRows();
  };
  /*--------------------Validate Password for Editing-------------------*/
  const validatePassword = async () => {
    try {
      await validateEditPassword(password);

      setIsEditAuthenticated(true);

      originalRowRef.current = {
        ...selectedRow,
      };

      setEditingRow(selectedRow.ulb_code);

      setShowPasswordModal(false);

      setPassword("");

      setTimeout(() => {
        gridRef.current?.api.redrawRows();
      }, 50);
    } catch {
      toast.error("Invalid Password");
    }
  };

  /*-------------------- For Future Use: Inline Editing -------------------*/
  const actionColumn = {
    headerName: "Edit",
    filter: false,
    sortable: false,
    resizable: false,
    width: 130,
    pinned: "left",

    cellRenderer: (params) => {
      const isEditing = editingRow === params.data.ulb_code;

      if (isEditing) {
        return (
          <div style={{ display: "flex", gap: "5px" }}>
            <button
              className="update-btn"
              onClick={() => updateRow(params.data)}
            >
              ✔
            </button>

            <button className="cancel-btn" onClick={() => cancelEdit()}>
              ❌
            </button>
          </div>
        );
      }

      return (
        <button disabled
          className="icon-edit"
          onClick={() => {
            if (isEditAuthenticated) {
              originalRowRef.current = { ...params.data };

              setEditingRow(params.data.ulb_code);

              setTimeout(() => {
                gridRef.current?.api.redrawRows();
              }, 50);

              return;
            }

            setSelectedRow(params.data);

            setShowPasswordModal(true);
          }}
        >
          ✏️
        </button>
      );
    },
  };

  const columns = [actionColumn, ...dashboardColumns];

  return (
    <>
      <div className="grid-toolbar">
        <button className="export-btn" onClick={exportExcel}>
          Export Excel{" "}
        </button>
        <input
          type="text"
          className="search-box"
          placeholder="🔍 Search all columns..."
          value={searchText}
          onChange={onSearchChange}
        />
      </div>

      <div className="grid-container">
        <div
          className="ag-theme-alpine"
          style={{
            height: "700px",
            width: "100%",
          }}
        >
          <AgGridReact
            ref={gridRef}
            rowData={rowData}
            columnDefs={columns}
            getRowId={(params) => params.data.ulb_code}
            context={{
              editingRow,
              setEditingRow,
              updateRow,
            }}
            rowClassRules={{
              "editing-row": (params) => params.data.ulb_code === editingRow,
            }}
            defaultColDef={defaultColDef}
            pagination={true}
            paginationPageSize={12}
            paginationPageSizeSelector={[84, 72, 60, 48, 36, 24, 12]}
            animateRows={true}
            onFilterChanged={onFilterChanged}
          />
        </div>
      </div>

      {showPasswordModal && (
        <div className="modal-overlay">
          <div className="password-modal">
            <h3>Edit Authorization</h3>

            <div className="password-input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && password.trim() !== "") {
                    validatePassword();
                  }
                }}
              />

              <span
                className="password-eye"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? "🙈" : "👁️"}
              </span>
            </div>

            <div className="modal-buttons">
              <button className="update-btn" onClick={validatePassword}>
                Submit
              </button>

              <button
                className="cancel-btn"
                onClick={() => {
                  setShowPasswordModal(false);
                  setPassword("");
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DashboardGrid;
